import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "scrollView" ]

    initialize() {
        this.didScroll = _.throttle(this.didScroll, 100)
    }

    connect() {
        let $button = $(this.element).find(".WeekCalendar-DaySelect.active")
        this.scrollToSelectedDay($button)
    }

    didSelectDay(e) {
        this.scrollToSelectedDay($(e.target))
        e.preventDefault()
    }

    scrollToSelectedDay($button) {
        $button.addClass('active').siblings().removeClass('active')
        this.updateDayPlanLink($button.data("day-plan-url"))
        let $dayPanel = $(this.element).find($button.attr("href"))
        let scrollOffset = $dayPanel[0].offsetLeft
        $(this.scrollViewTarget).scrollLeft(scrollOffset)
    }

    didScroll(e) {
        let currentScrolledDay = this.currentScrolledDay()
        if(currentScrolledDay === 0){
            Turbo.visit($(this.element).find(".WeekCalendar-Day-placeholder:first-child").attr("href"), { action: "replace", frame: "calendar-content" })
        } else if(currentScrolledDay === 6) {
            Turbo.visit($(this.element).find(".WeekCalendar-Day-placeholder:last-child").attr("href"), { action: "replace", frame: "calendar-content" })
        } else {
            this.selectDay(currentScrolledDay - 1)
        }
    }

    currentScrolledDay() {
        let elementWidth = $(this.scrollViewTarget).children()[0].clientWidth
        return Math.round(this.scrollViewTarget.scrollLeft / elementWidth)      
    }

    selectDay(i) {
        let $day = $($(this.element).find(".WeekCalendar-DaySelect")[i])
        $day.addClass('active').siblings().removeClass('active')
        this.updateDayPlanLink($day.data("day-plan-url"))
    }

    updateDayPlanLink(url) {
        $(".js-calendar-day-plan-link").each(function() {
            $(this).attr(this.tagName === "OPTION" ? "value" : "href", url)
        })
    }
}
